const firebaseConfig = {
    apiKey: "AIzaSyAyE3Tjc0BfUKeE5DzL5O4fJJPUaeL9ZoY",
    authDomain: "react-auth-859a7.firebaseapp.com",
    projectId: "react-auth-859a7",
    storageBucket: "react-auth-859a7.appspot.com",
    messagingSenderId: "413362499295",
    appId: "1:413362499295:web:7907f439ea1a8d9920c36a"
  };
  export default firebaseConfig;